@switch (data.size) {
  @case ("small") {
    <div class="h-5 w-full"></div>
  }
  @case ("medium") {
    <div class="h-[50px] w-full"></div>
  }
  @case ("large") {
    <div class="h-[100px] w-full"></div>
  }
}
